module.exports = "/_next/static/images/play-button-8043798812db0ccbe26e0f4fc095ded1.png";